import moment from 'moment';
import 'jspdf-autotable'
import formatCurrency from "format-currency";
import _ from "lodash";

class ChargecodesController {
  constructor($rootScope, $http, toastr, AuthenticationService) {
    "ngInject";
    this.name = 'customers';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.chargecodes = [];
    this.customers = [];
    this.toastr = toastr;
    this.billableFilter = 'all';
    this.expirationFilter = 'notexpired';
    let self = this;
    this.auth = AuthenticationService;

    this.$http.get($rootScope.apiHost+"/api/admin/customers", {withCredentials: true}).then(function (success) {
      self.customers = success.data;
    });

    this.directChargeCodeFilter = {
      name: '',
      customerId: 0,
      contractId: 0,
      projectId: 0,
      billable: true,
      expirationStatus: 'notexpired'
    }

    this.indirectChargeCodeFilter = {
      name: '',
      billable: false,
      expirationStatus: 'notexpired'
    }

    this.directFilterRefresh = false;
    this.indirectFilterRefresh = false;

    this.chargeCodeColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/chargecodes/"+record.id+"\" >"+record.name+"</a>";
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          if(record.description) {
            return record.description;
          } else {
            return '';
          }
        }
      },
      {
        displayName: 'Contract',
        value: 'contract',
        sortable: true,
        sortValue: 'contract',
        dataType: 'text',
        formatting: function (record) {
          if(record.contract && record.contract.contractName) {
            return record.contract.contractName;
          } else {
            return 'N/A';
          }
        }
      },
      {
        displayName: 'Project',
        value: 'taskOrder',
        sortable: true,
        sortValue: 'taskOrder',
        dataType: 'text',
        formatting: function (record) {
          if(record.taskOrder && record.taskOrder.name) {
            return record.taskOrder.name;
          } else {
            return 'N/A';
          }
        }
      },
      {
        displayName: 'Effective Date',
        value: 'effectiveDate',
        sortable: true,
        sortValue: 'effectiveDate',
        dataType: 'date',
        formatting: function (record) {
          return moment(record.effectiveDate).format("MMM, DD, YYYY")
        }
      },
      {
        displayName: 'Expiration Date',
        value: 'expirationDate',
        sortable: true,
        sortValue: 'expirationDate',
        dataType: 'date',
        formatting: function (record) {
          return moment(record.expirationDate).format("MMM, DD, YYYY")
        }
      },
      {
        displayName: 'Rate',
        value: 'popRate.rate',
        secure: this.auth.hasPermission('PERM_VIEW_PROJECT_FUNDING'),
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return '$'+formatCurrency(record.popRate.rate);
        }
      }
    ];


    this.indirectChargeCodeColumns = [
      {
        displayName: 'Name',
        value: 'name',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/chargecodes/"+record.id+"\" >"+record.name+"</a>";
        }
      },
      {
        displayName: 'Description',
        value: 'description',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          if(record.description) {
            return record.description;
          } else {
            return '';
          }
        }
      },
      {
        displayName: 'Effective Date',
        value: 'effectiveDate',
        sortable: true,
        sortValue: 'effectiveDate',
        dataType: 'date',
        formatting: function (record) {
          return moment(record.effectiveDate).format("MMM, DD, YYYY")
        }
      },
      {
        displayName: 'Expiration Date',
        value: 'expirationDate',
        sortable: true,
        sortValue: 'expirationDate',
        dataType: 'date',
        formatting: function (record) {
          if(record.expirationDate) {
            return moment(record.expirationDate).format("MMM, DD, YYYY")
          } else {
            return 'Does Not Expire'
          }
        }
      }
    ];





    this.directChargeCodeFilterCriteria = function () {
      return "billable="+self.directChargeCodeFilter.billable+"&name="+self.directChargeCodeFilter.name+"&customerId="+self.directChargeCodeFilter.customerId+"&contractId="+self.directChargeCodeFilter.contractId+"&projectId="+self.directChargeCodeFilter.projectId+"&expirationStatus="+self.directChargeCodeFilter.expirationStatus;
    }

    this.indirectChargeCodeFilterCriteria = function () {
      return "billable=false&name="+self.indirectChargeCodeFilter.name+"&expirationStatus="+self.indirectChargeCodeFilter.expirationStatus;
    }

  }

  filterCustomer() {
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/admin/contracts/bycustomer?customer="+this.directChargeCodeFilter.customerId, {withCredentials: true}).then(function (success) {
      self.contractsForCustomer = success.data;
    });

    this.filterDirectChargeCodes();
  }

  filterContracts(){
    let self = this;
    this.$http.get(self.$rootScope.apiHost+"/api/admin/projects/bycontract?contract="+this.directChargeCodeFilter.contractId+"&openOnly=false", {withCredentials: true}).then(function (success) {
      self.projectsForContract = success.data;
    });

    this.filterDirectChargeCodes();
  }

  filterDirectChargeCodes() {
    if(this.directChargeCodeFilter.customerId > 0) {
      let selectedCustomer = _.find(this.customers, {"id" : this.directChargeCodeFilter.customerId});
      this.filteredContracts = selectedCustomer.contracts;

      if(this.directChargeCodeFilter.contractId > 0) {

      } else {
      }
    } else {
      this.filteredContracts = [];
      this.filteredProjects = [];
      this.directChargeCodeFilter.contractId = 0;
      this.directChargeCodeFilter.projectId = 0;
    }

    this.directFilterRefresh = true;
  }


  filterIndirectChargeCodes() {
    this.indirectFilterRefresh = true;
  }

}

export default ChargecodesController;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecodes/chargecodes.controller.js